<template>
  <div>
    <el-card>
      <div
        slot="header"
        class="clearfix"
      >
        <span>Egyedi képviselői árak</span>
        <el-button
          v-can="'customrepresentativeprice.create'"
          style="float: right; margin-top: -5px;"
          type="success"
          size="small"
          icon="el-icon-plus"
          @click="$router.replace('/representative-processes/representative-prices/custom/add')"
        >
          Új árlista
        </el-button>
      </div>
      <price-list />
    </el-card>
    <template v-if="$route.meta.showUpdatePartnerSpecialPriceDialog">
      <special-price-dialog
        :list-id="$route.params.id"
        dialog-type="update"
      />
    </template>
    <template v-if="$route.meta.showViewPartnerSpecialPriceDialog">
      <special-price-dialog
        :list-id="$route.params.id"
        dialog-type="view"
      />
    </template>
    <template v-if="$route.meta.showUpdateShopSpecialPriceDialog">
      <special-price-dialog
        :update-id="$route.params.id"
        :update-type="'shop'"
        dialog-type="update"
      />
    </template>
    <template v-if="$route.meta.showAddSpecialPriceDialog">
      <special-price-dialog
        dialog-type="add"
        :copy-from="$route.params.copyFrom || null"
        :add-type="$route.params.type || null"
      />
    </template>
  </div>
</template>
<script>
  import PriceList from '../../components/representativeProcesses/specialPrices/List';
  import SpecialPriceDialog from '../../components/representativeProcesses/specialPrices/Dialog';
  export default {
    components: { PriceList, SpecialPriceDialog }
  }
</script>
